export default __webpack_public_path__ + "static/media/twitter.e7886f46.svg";